// Этап 6, раздел 4 «Тарифы» (docs/PLAN.md) — одна строка таблицы тарифов в PlansScreen.tsx,
// переключается между просмотром и инлайн-редактированием. Тот же приём самодостаточного
// компонента со своим busy/error, что и SubscriptionCard.tsx (раздел 3).
import { useState } from "react";

import { type AdminPlan, ApiError, updatePlan } from "../api/client";

export function PlanRow({ plan, onChanged }: { plan: AdminPlan; onChanged: () => void }) {
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [title, setTitle] = useState(plan.title);
  const [price, setPrice] = useState(String(plan.price));
  const [durationDays, setDurationDays] = useState(String(plan.duration_days));
  const [deviceLimit, setDeviceLimit] = useState(String(plan.device_limit));

  function resetFields() {
    setTitle(plan.title);
    setPrice(String(plan.price));
    setDurationDays(String(plan.duration_days));
    setDeviceLimit(String(plan.device_limit));
    setError(null);
  }

  async function save() {
    setBusy(true);
    setError(null);
    try {
      await updatePlan(plan.id, {
        title,
        price: Number(price),
        duration_days: Number(durationDays),
        device_limit: Number(deviceLimit),
      });
      setEditing(false);
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось сохранить тариф");
    } finally {
      setBusy(false);
    }
  }

  async function toggleActive() {
    setBusy(true);
    setError(null);
    try {
      await updatePlan(plan.id, { is_active: !plan.is_active });
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось изменить статус");
    } finally {
      setBusy(false);
    }
  }

  if (editing) {
    return (
      <tr>
        <td>{plan.code}</td>
        <td>
          <input value={title} onChange={(e) => setTitle(e.target.value)} style={{ width: "100%" }} />
        </td>
        <td>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            style={{ width: 80 }}
          />{" "}
          {plan.currency}
        </td>
        <td>
          <input
            type="number"
            value={durationDays}
            onChange={(e) => setDurationDays(e.target.value)}
            style={{ width: 64 }}
          />
        </td>
        <td>
          <input
            type="number"
            min={1}
            max={5}
            value={deviceLimit}
            onChange={(e) => setDeviceLimit(e.target.value)}
            style={{ width: 56 }}
          />
        </td>
        <td>{plan.is_trial ? "да" : "—"}</td>
        <td>{plan.is_active ? "активен" : "архивный"}</td>
        <td style={{ whiteSpace: "nowrap" }}>
          <button className="primary" disabled={busy} onClick={save} style={{ marginRight: 8 }}>
            Сохранить
          </button>
          <button
            className="secondary"
            disabled={busy}
            onClick={() => {
              setEditing(false);
              resetFields();
            }}
          >
            Отмена
          </button>
          {error && <div className="error-text" style={{ marginTop: 8, marginBottom: 0 }}>{error}</div>}
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{plan.code}</td>
      <td>
        {plan.title}
        {plan.is_bundle && " · бандл"}
      </td>
      <td>
        {plan.price} {plan.currency}
      </td>
      <td>{plan.duration_days}</td>
      <td>{plan.device_limit}</td>
      <td>{plan.is_trial ? "да" : "—"}</td>
      <td>{plan.is_active ? "активен" : "архивный"}</td>
      <td style={{ whiteSpace: "nowrap" }}>
        <button className="secondary" disabled={busy} onClick={() => setEditing(true)} style={{ marginRight: 8 }}>
          Редактировать
        </button>
        <button className="secondary" disabled={busy} onClick={toggleActive}>
          {plan.is_active ? "Архивировать" : "Восстановить"}
        </button>
        {error && <div className="error-text" style={{ marginTop: 8, marginBottom: 0 }}>{error}</div>}
      </td>
    </tr>
  );
}
